import { HeartRatePacket } from './heartRatePacket';
import { RC900Packet } from './RC900Packet';

const HEART_RATE_MONITOR = 0x78;
const IGNORED_IDENTIFIERS = [0x05, 0x79, 0x7A, 0x7B]; // currently unsuported devices like bikes etc
export class MetricsMessageHandler {
  public handleIncommingMessage(data: any) {
    const messageIdentifier = data[8] % 256;
    if (IGNORED_IDENTIFIERS.indexOf(messageIdentifier) !== -1) {
      return undefined;
    }

    if (messageIdentifier === HEART_RATE_MONITOR) {
      return new HeartRatePacket(data);
    }
    return new RC900Packet(data);
  }
}
